import { render } from "./CustomerOrders.vue?vue&type=template&id=4958c3d3&scoped=true"
import script from "./CustomerOrders.vue?vue&type=script&lang=js"
export * from "./CustomerOrders.vue?vue&type=script&lang=js"

import "./CustomerOrders.vue?vue&type=style&index=0&id=4958c3d3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4958c3d3"]])

export default __exports__